module.exports = __webpack_public_path__ + "img/Fondo_Web.6f0dd280.svg";